export const pmisPlaygroundCategoriesMixin = {
    data: function () {
        return {
            categories: [
                {
                    "abbr": "AIV",
                    "name": "Analitika in vizualizacija"
                },
                {
                    "abbr": "OMP",
                    "name": "Obdelava masovnih podatkov"
                },
                {
                    "abbr": "NP",
                    "name": "Nadzorne plošče"
                },
                {
                    "abbr": "DT",
                    "name": "Digitalne tržnice"
                },
                {
                    "abbr": "ZIP",
                    "name": "Zajem in int. podatkov"
                },
                {
                    "abbr": "IOT",
                    "name": "Upravljanje z IoT"
                },
                {
                    "abbr": "HP",
                    "name": "Hramba podatkov"
                },
                {
                    "abbr": "OTHR",
                    "name": "Drugo"
                },
            ]
        };
    }
};
